.wrap {
  position: relative;
  display: block;
  width: 100%;
}

.input {
  display: block;
  width: 100%;
  min-height: var(--touch-min);
  padding: 0 var(--space-3);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-md);
  background: var(--surface-panel);
  color: var(--text);
  font: inherit;
  font-size: var(--b-text-lead);
  transition:
    border-color var(--dur) var(--ease-out),
    box-shadow var(--dur) var(--ease-out);
}

.input::placeholder {
  color: var(--text-subtle);
}

.input:hover {
  border-color: var(--text-muted);
}

.input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-tint);
}

.input:disabled {
  background: var(--surface-sunken);
  opacity: 0.7;
}

.input[aria-invalid='true'] {
  border-color: var(--danger);
}

.input[aria-invalid='true']:focus {
  box-shadow: 0 0 0 3px var(--danger-tint);
}

.icon {
  position: absolute;
  inset-inline-start: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
}

.withIcon .input {
  /* stylelint-disable-next-line declaration-property-value-disallowed-list -- ruimte voor het pictogram (tikdoel 44) */
  padding-inline-start: 44px;
}

.large .input {
  min-height: 56px;
  font-size: var(--text-lg);
  border-radius: var(--radius-lg);
}
